import React, { useState, useEffect } from 'react';
import supermanImage from 'assets/images/superman_rwt_no_background.png';
import {
  ChatContainer,
  ChatHeader,
  HeaderAvatar,
  HeaderInfo,
  HeaderName,
  HeaderStatus,
  HeaderIcons,
  MessagesContainer,
  MessageBubble,
  MessageText,
  MessageTime,
  MessageStatus,
  TypingIndicator,
  TypingDot,
  InputContainer,
  InputField,
  InputIcons,
  PhoneFrame,
} from './WhatsAppChat.styles';

const messages = [
  {
    id: 1,
    text: 'I want to know how much I owe to client ABC. The info should be in the Google Drive.',
    time: '10:41 AM',
    isUser: true,
    delay: 500,
  },
  {
    id: 2,
    text: '📂 Scanning Drive...',
    time: '10:42 AM',
    isUser: false,
    delay: 1500,
  },
  {
    id: 3,
    text: 'Based on the "Invoice_ABC_Q1.pdf" file, your current outstanding balance is $4,250.00.',
    time: '10:42 AM',
    isUser: false,
    delay: 2500,
  },
  {
    id: 4,
    text: 'Nice, do I have a meeting with them this week?',
    time: '10:44 AM',
    isUser: true,
    delay: 4000,
  },
  {
    id: 5,
    text: 'No meetings found for this week. However, you are scheduled to meet with Client ABC next Thursday, Feb 26th at 2:00 PM.',
    time: '10:45 AM',
    isUser: false,
    delay: 5500,
  },
  {
    id: 6,
    text: 'Great, please send them the invoice for what they owe.',
    time: '10:46 AM',
    isUser: true,
    delay: 7000,
  },
  {
    id: 7,
    text: '✅ Invoice_ABC_Q1.pdf has been sent to client ABC via email.',
    time: '10:46 AM',
    isUser: false,
    delay: 8500,
  },
];

const WhatsAppChat = () => {
  const [visibleMessages, setVisibleMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex >= messages.length) {
      // Reset animation after all messages shown
      const resetTimer = setTimeout(() => {
        setVisibleMessages([]);
        setCurrentIndex(0);
      }, 5000);
      return () => clearTimeout(resetTimer);
    }

    const message = messages[currentIndex];

    // Show typing indicator for bot messages
    if (!message.isUser && currentIndex > 0) {
      setIsTyping(true);
      const typingTimer = setTimeout(() => {
        setIsTyping(false);
        setVisibleMessages((prev) => [...prev, message]);
        setCurrentIndex((prev) => prev + 1);
      }, 1000);
      return () => clearTimeout(typingTimer);
    }

    const timer = setTimeout(() => {
      setVisibleMessages((prev) => [...prev, message]);
      setCurrentIndex((prev) => prev + 1);
    }, message.delay);
    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <PhoneFrame>
      <ChatContainer>
        <ChatHeader>
          <HeaderAvatar>
            <img src={supermanImage} alt="RWT Super Agent" />
          </HeaderAvatar>
          <HeaderInfo>
            <HeaderName>RWT Super Agent</HeaderName>
            <HeaderStatus>Online</HeaderStatus>
          </HeaderInfo>
          <HeaderIcons>
            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
              <path d="M15.9 14.3H15l-.3-.3c1-1.1 1.6-2.7 1.6-4.3 0-3.7-3-6.7-6.7-6.7S3 6 3 9.7s3 6.7 6.7 6.7c1.6 0 3.2-.6 4.3-1.6l.3.3v.8l5.1 5.1 1.5-1.5-5-5.2zm-6.2 0c-2.6 0-4.6-2.1-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2.1 4.6 4.6-2 4.6-4.6 4.6z" />
            </svg>
          </HeaderIcons>
        </ChatHeader>

        <MessagesContainer>
          {visibleMessages.map((msg) => (
            <MessageBubble key={msg.id} $isUser={msg.isUser}>
              <MessageText>{msg.text}</MessageText>
              <MessageTime>
                {msg.time}
                {msg.isUser && <MessageStatus>✓✓</MessageStatus>}
              </MessageTime>
            </MessageBubble>
          ))}
          {isTyping && (
            <MessageBubble $isUser={false}>
              <TypingIndicator>
                <TypingDot $delay="0s" />
                <TypingDot $delay="0.2s" />
                <TypingDot $delay="0.4s" />
              </TypingIndicator>
            </MessageBubble>
          )}
        </MessagesContainer>

        <InputContainer>
          <InputIcons>
            <span>😊</span>
          </InputIcons>
          <InputField placeholder="Message" disabled />
          <InputIcons>
            <span>📎</span>
            <span>📷</span>
          </InputIcons>
        </InputContainer>
      </ChatContainer>
    </PhoneFrame>
  );
};

export default WhatsAppChat;
